<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div>
        <div>
          <div class="content-1">
            <header>
              <div>
                <div class="left">
                  <div class="content">
                    <div v-on:click="createNewStudy" style="cursor: pointer">
                      <h4>Create New Study</h4>
                    </div>
                    <div class="create-study" v-on:click="createNewStudy">
                      <div>
                        <Fai :icon="['far', 'plus-circle']"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="content">

                  </div>
                </div>
              </div>
            </header>
            <section class="body">
              <div>
                <div>
                  <div v-if="areStudiesLoading">
                    <div class="content">
                      <div class="centered-row">
                        <div class="loading">
                          <Fai :icon="['far', 'circle-notch']" spin/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="areStudiesFinishedLoadingSuccessfully">
                    <div v-if="areStudiesEmpty">
                      <div class="content">
                        <div class="text-1">
                          <span>It appears you have not created any studies.</span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="studies">
                        <div v-for="(datum, i) in sortedStudies" :key="i">
                          <div>
                            <div class="study">
                              <div class="row align-center">
                                <div class="row align-center left">
                                  <div v-if="datum.study.published">
                                    <div class="published-icon">
                                      <Fai :icon="['fas', 'check-circle']"/>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div class="not-published-icon">
                                      <Fai :icon="['fas', 'clock']"/>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="name">
                                      <div>
                                        <router-link :to="datum.route">
                                          <div @click="onStudyClick(datum.study)">
                                            <h5>
                                              <span v-if="datum.study.name">{{datum.study.name}}</span>
                                              <span v-else>Unnamed Study</span>
                                            </h5>
                                          </div>
                                        </router-link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row align-center right">
                                  <div class="duplicate-study-icon" @click="onDuplicateClick(datum.study)">
                                    <Fai :icon="['far', 'clone']"/>
                                  </div>
                                  <div class="remove-study-icon" @click="onTrashClick(datum.study)">
                                    <Fai :icon="['fal', 'trash-alt']"/>
                                  </div>
                                </div>
                              </div>
                              <div class="tags">
                                <small>
                                <span v-for="(tag, j) in datum.derived.tagsWithCommas" :key="j">
                                  {{tag}}
                                </span>
                                </small>
                              </div>
                              <div class="study-creation">
                                <span>Created: {{datum.derived.dateCreated}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="areStudiesInAFailedState">
                    <div class="text-1">
                      <h5>
                        {{studiesError}}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div v-if="isConfirmDeleteStudyDialogShowing">
          <Modal>
            <div class="confirm-delete-study-dialog pdng-1">
              <div>
                <div class="exit-row">
                  <Fai :icon="['fal', 'times']" @click="dialogCancel()"/>
                </div>
                <div class="pdng-1">
                  <div class="prompt-row">
                    <span>Are you sure you want to delete this study?</span>
                  </div>
                  <div class="actions-row pdng-1 top">
                    <div class="action">
                      <button type="button" class="pure-button bigmi-wide-button bigmi-cyan-blue-2-button"
                              @click="dialogCancel()">
                        <span>BACK</span>
                      </button>
                    </div>
                    <div class="action">
                      <button type="button" class="pure-button bigmi-wide-button bigmi-red-2-button"
                              @click="dialogConfirm()">
                        <Fai v-if="isStudyDeleting" :icon="['far', 'circle-notch']" spin/>
                        <span v-else>{{dialogDeleteButtonText}}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import {
      DELETE_STUDY,
      GET_PROFILE_DROPDOWN_TEXT,
      GET_STUDIES_OF_USER, GET_STUDY, LOADING_COMPLETED_FAILURE, LOADING_COMPLETED_SUCCESS,
      LOADING_STARTED, R_NAME_CREATE_A_STUDY, R_NAME_CREATE_STUDY_LOADING,
      R_NAME_MY_PROFILE, R_NAME_PURCHASES, RESET_SELECTED_QUALIFICATIONS, SET_RESET_SELECTED_QUALIFICATIONS,
      A_RESET_IDEA_COACH_STATE
    } from "../../services/constants"

    export default {
        name: "MyStudies",

      created() {

      },

      data() {
        return {
          removeStudyDialogShowState: false,
          studyToBeRemoved: null,
        }
      },
      computed: {
        ...mapGetters([
          GET_PROFILE_DROPDOWN_TEXT,
          GET_STUDIES_OF_USER,
        ]),
        username() {
          return this[GET_PROFILE_DROPDOWN_TEXT]
        },
        routeUserProfile() {
          return {
            name: R_NAME_MY_PROFILE
          }
        },
        studiesState() {
          return this.$store.state.dataModule.studies
        },
        studies() {
          return this[GET_STUDIES_OF_USER].map(datum => {
            datum.derived.tagsWithCommas = datum.derived.tags.map((tag, i, tags) => {
              return i !== tags.length - 1 ? `${tag},` : tag
            })
            return datum
          })
        },
        sortedStudies() {
          const shallowCopy = this.studies.slice()
          shallowCopy.sort((a, b) => {
            if (a.study.published && !b.study.published) {
              return -1
            }
            if (!a.study.published && b.study.published) {
              return 1
            }
            return 0
          })
          shallowCopy.forEach(d => {
            // console.log(d.study.sourcingMethod)
          })
          return shallowCopy
        },
        areStudiesLoading() {
          return this.studiesState.loadingState === LOADING_STARTED
        },
        areStudiesFinishedLoadingSuccessfully() {
          return this.studiesState.loadingState === LOADING_COMPLETED_SUCCESS
        },
        areStudiesInAFailedState() {
          return this.studiesState.loadingState === LOADING_COMPLETED_FAILURE
        },
        studiesError() {
          // return this.studiesState.error.message
          return 'Loading studies failed'
        },
        areStudiesEmpty() {
          return this.studies.length === 0
        },
        routeCreateStudy() {
          return {
            name: R_NAME_CREATE_A_STUDY,
          }
        },
        isConfirmDeleteStudyDialogShowing() {
          return this.removeStudyDialogShowState
        },
        studyDeletingLoadingState() {
          return this.$store.state.dataModule.deleteStudyState.loadingState
        },
        isStudyDeleting() {
          return this.studyDeletingLoadingState === LOADING_STARTED
        },
        isStudyDeletedSuccessfully() {
          return this.studyDeletingLoadingState === LOADING_COMPLETED_SUCCESS
        },
        didStudyDeleteFail() {
          return this.studyDeletingLoadingState === LOADING_COMPLETED_FAILURE
        },
        dialogDeleteButtonText() {
          if (this.didStudyDeleteFail) {
            return 'TRY AGAIN'
          }
          return 'DELETE'
        },
        myPuchasesLink(){
          return {
            name: R_NAME_PURCHASES
          }
        },
        userHasPurchases(){
          return this.$store.state.dataModule.purchases.data.length > 0
        },
      },
      methods: {
        onStudyClick(study) {
          this.$store.dispatch(GET_STUDY, study.id).then(()=>{
            this.$store.dispatch(A_RESET_IDEA_COACH_STATE);
            return this.$store.dispatch(RESET_SELECTED_QUALIFICATIONS)
          })
        },
        onTrashClick(study) {
          this.studyToBeRemoved = study
          this.removeStudyDialogShowState = true
        },
        onDuplicateClick(study) {
          this.$store.commit(SET_RESET_SELECTED_QUALIFICATIONS)
          this.$store.dispatch(A_RESET_IDEA_COACH_STATE);
          this.$store.dispatch(GET_STUDY, study.id).then(()=>{
            this.$router.push({
              name: R_NAME_CREATE_STUDY_LOADING,
              query: {
                duplicate: true
              }
            })
          })
        },
        dialogCancel() {
          this.removeStudyDialogShowState = false
        },
        dialogConfirm() {
          this.$store.dispatch(DELETE_STUDY, this.studyToBeRemoved.id)
            .then(() => {
              if (this.isStudyDeletedSuccessfully) {
                this.removeStudyDialogShowState = false
                this.studyToBeRemoved = null
              }
            })
        },
        createNewStudy(){
          this.$store.commit(SET_RESET_SELECTED_QUALIFICATIONS)
          this.$store.dispatch(A_RESET_IDEA_COACH_STATE);
          this.$router.push({
            name: R_NAME_CREATE_STUDY_LOADING
          })
        }
      }

    }
</script>

<style scoped lang="scss">
  @import "../../scss/main";

  .content-1 {
    margin: 0 60px;
  }

  header > div {
    display: flex;
    align-items: center;

    .create-study {
      font-size: 2em;
      margin: 0 0 0 1em;
      @media #{$mobile} {
        margin: 0;
      }

      a {
        color: inherit;
      }

      cursor: pointer;
    }

    > .left, > .right {
      display: inline-block;
      width: 50%;

      .content {
        display: flex;
        align-items: center;

        .row {
          display: flex;
        }
      }
    }

    > .left, > .right {
      font-size: 17px;
    }

    > .right {
      .content {
        justify-content: flex-end;
        color: $cyan-blue-3;

        .row {
          justify-content: flex-end;
        }
      }
    }

    > .left {
      .content {
        color: $red-2;
        @media #{$mobile} {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
  }

  .purchases{
    color: $red-2;
    font-weight: bold;
    text-decoration: none;
  }

  .profile-link {
    a {
      color: inherit;
    }
  }

  .loading {
    color: $red-2;
  }

  .text-1 {
    color: $red-2;
  }

  section.body {
    .content {
      padding: 2em 0;
    }
  }

  .published-icon, .not-published-icon {
    font-size: 22px;
    margin: 0 9px 0 0;
  }

  .published-icon {
    color: $red-2;
  }

  .not-published-icon {
    color: $yellow-1;
  }

  .remove-study-icon {
    font-size: 22px;
    color: $cyan-blue-3;
    cursor: pointer;
  }

  .duplicate-study-icon {
    font-size: 22px;
    color: $cyan-blue-3;
    cursor: pointer;
    padding-right: 10px;
  }

  .studies {
    padding: 1em 0 5em 0;
  }

  .study {
    border-bottom: 1px solid $red-2;
    padding: 30px 0;
    .name {
      color: $cyan-blue-3;
      font-size: 17px;

      h5 {
        margin: 1em 0;
      }

      a {
        color: $cyan-1;
        text-decoration: none;
      }
    }

    .left {
      flex-grow: 1;
    }

    .tags {
      color: $gray-3;
    }

    .study-creation {
      font-weight: 300;
      font-size: 15px;
      color: $cyan-1;
      padding: 5px 0 0 0;
    }

    .view-count {
    }
  }

  .confirm-delete-study-dialog {
    background-color: $white-1;
    border-radius: 5px;

    .exit-row {
      display: flex;
      justify-content: flex-end;
    }

    .actions-row {
      display: flex;
      justify-content: space-between;
      .action {
        width: calc(50% - 1em);
      }
    }
  }
</style>
